import { render, staticRenderFns } from "./DetectionJson.vue?vue&type=template&id=06429355&scoped=true&"
import script from "./DetectionJson.vue?vue&type=script&lang=js&"
export * from "./DetectionJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06429355",
  null
  
)

export default component.exports